window._ = require('lodash');
window.$ = window.jQuery = require('jquery');

try {
    require('overlayscrollbars');
    require('bootstrap');
    require('icheck-bootstrap');
    require('select2');
    require('../../vendor/almasaeed2010/adminlte/dist/js/adminlte');
} catch (e) {
    console.log(e, 'Si è verificato un errore');
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import DataTable from 'datatables.net-dt';
import languageIT from 'datatables.net-plugins/i18n/it-IT.mjs';
import 'datatables.net-bs4';

Object.assign(DataTable.defaults, {
    "language": languageIT
});
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

import QrScanner from 'qr-scanner';
window.QrScanner = QrScanner;

import alertify from 'alertifyjs';
window.alertify = alertify;

import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconUrl:       '/images/leaflet/marker-icon.png',
    iconRetinaUrl: '/images/leaflet/marker-icon-2x.png',
    shadowUrl:     '/images/leaflet/marker-shadow.png',
});

window.L = L;
window.leafletReady = Promise.resolve(L);
